export default __webpack_public_path__ + "static/media/app_logo.6b592b9f.png";